import { useContext } from 'react';

import ABTestContextGlobal from '../context/ab-test-context-global';

/**
 * Retrieves the current AB Test configuration by test name.
 */
const useAbTest = (testName: string) => {
  const { tests } = useContext(ABTestContextGlobal);

  const currentTest = tests?.[testName];

  return currentTest;
};

export default useAbTest;
